export default function isAMTTrip(catalogName: string): boolean {
  return catalogName.includes('-AMT');
}
